import { object, string, array, number } from 'yup';
import { formErrorStore } from '../store/global-stores';
import { showToast } from './toast-handler.js';
import { IncidentCategory } from '../product/ams/modules/incident/enum';

// AMS validations
export const TaskSchema = object({
    from_department_id: string().required('Department selection required.'),
    to_department_id: string().required('Department selection required.'),
    assigned_to: array().required('Assigned To selection required.').min(1, 'At least one assigned to must be selected'),
    source_id: string().required('Source selection required.'),
    theme_id: string().required('Theme selection required.'),
    title: string().required('Task title required.'),
    due_date: string().required('Due date required.'),
    priority: string().required('Priority selection required.'),
    progress_status: string().required('Progress selection required.'),
});

export const DraftTaskSchema = object({
    title: string().required('Task title required.'),
});

// Comment Schema

export const CommentSchema = object({
    comment: string().required('Comment field is required'),
    type:string().optional(),
});

// Debrief Schema

export const DebriefSchema = object({
    category: number().required('Select at least one category'),
    incident_number: string().when('category', {
        is: (category) => {
            return category == null || category == IncidentCategory.INCIDENT;
        },
        then: () => string().required('Incident number is required').min(10, 'Incident number must have atleast 10 digits'),
        otherwise: () => string(),
    }),
    incident_date: string().required('Incident date selection is required'),
    property_type_id: string().when('category', {
        is: (category) => {
            return category == IncidentCategory.TRAINING || category == IncidentCategory.EXERCISE;
        },
        then: () => string().required('Property Type is required'),
        otherwise: () => string(),
    }),
    appliance_id: string().nullable(),
    learningOutcomes: array().of(
        object({
            source_id: string().required('Source is required'),
            theme_id: string().required('Theme is required'),
            outcome_type: string().required('Outcome Type is required'),
        })
    ),
}).transform((originalObject) => {
    const { ...obj } = originalObject;
    // If category is 'incident' or null, remove property_type_id in error details
    if (obj.category === IncidentCategory.INCIDENT || obj.category == null) {
        obj.property_type_id = '';
    }
    // If category is not 'incident', remove incident_number in error details
    if (obj.category != IncidentCategory.INCIDENT && obj.category != null) {
        obj.incident_number = '';
    }

    return obj;
});

// AMS Validations ends

// Generic Validations starts
export const LoginSchema = object({
    email: string().email('Invalid Email').required('Email field is required'),
    password: string().required('Password field is required'),
    mail_otp: number().nullable(),
});

export const ForgotPasswordSchema = object({
    email: string().email('Invalid Email').required('Email field is required'),
});

export const PasswordResetSchema = object({
    password: string().required('Password field is required').min(8, 'Password must be at least 8 characters long'),
    confirmPassword: string().required('Confirm Password field is required'),
    // .oneOf([string().ref('password')], 'Passwords must match'),
});

export const UserSchema = object({
    name: string().required('First name is required'),
    surname: string().required('Surname is required'),
    email: string().email('Email is invalid').required('Email is required'),
    mail_otp: number().nullable(),
});
// Generic Validations ends
// Helpers
//
export const handleValidation = async (schema, formData) => {
    try {
        // validate the schema first
        await schema.validate({ ...formData }, { abortEarly: false });
        formErrorStore.clearErrors();
        return true;
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleErrors(error);
            formErrorStore.addErrors(errors);
            showToast({ severity: 'info', summary: 'Invalid Form' }, 'Input data invalid');
        }
        return false;
    }
};
// Validation errors handler
export const handleErrors = (errors) => {
    let validationError = [];
    // Handle validation errors here
    for (const error of errors.inner) {
        const errorString = snakeToCamel(error.path);
        // populates the error message
        validationError[errorString] = error.message;
    }
    return validationError;
};

// converts strings like company_id to companyId
function snakeToCamel(str) {
    return str.replace(/_([a-z])/g, (_, match) => match.toUpperCase());
}
